import { NgModule } from '@angular/core';

import { CONTENT_COMPONENTS, ApContentModule } from '@ap/content';
import { ApAccordionService } from '@ap/accordion';

import { ContentTypes } from './content-components.model';
import {
    ApIconListItemWrapperComponent,
    ApPanelWrapperComponent,
    ApCardWrapperComponent,
    ApImageCardWrapperComponent
} from './content-components.component';

@NgModule({
    imports: [
        ApContentModule,
        ApIconListItemWrapperComponent,
        ApPanelWrapperComponent,
        ApCardWrapperComponent,
        ApImageCardWrapperComponent
    ],
    providers: [{ provide: CONTENT_COMPONENTS, useValue: ContentTypes, multi: true }, ApAccordionService]
})
export class ApContentComponentsModule {}
